module.exports = __webpack_public_path__ + "img/LEVANTO_RIM.1da82c18.png";